import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { fetchDevicesIds } from './actionCreators';

interface InitialState {
  devicesIds: string [],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  devicesIds: [],
  isLoading: false,
  error: '',
};

export const devicesIdsSlice = createSlice({
  name: 'devicesIds',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchDevicesIds.fulfilled.type]: (state, action: PayloadAction<string []>) => {
      state.isLoading = false;
      state.error = '';
      state.devicesIds = action.payload;
    },
    [fetchDevicesIds.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchDevicesIds.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default devicesIdsSlice.reducer;
